<style scoped="scoped" lang="scss"></style>

<template>
  <div style="display: inline;">
    <!-- table表格 -->
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/basic/material/page" getKey="rows" @afterGet="afterGet" :columns="columns">
      <!-- 搜索框插槽 -->
      <template #conditions>
        <el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
          <el-form-item :label="$t('wuliaobianma')">
            <el-input v-model="yt.conditions.code"></el-input>
          </el-form-item>
          <el-form-item :label="$t('wuliaomingcheng')">
            <el-input v-model="yt.conditions.name"></el-input>
          </el-form-item>
          <el-form-item :label="$t('jibenfenlei')">
            <yi_dictionary_select :type="'CUSTOMER_MATERIAL_TYPE'" :ids.sync="yt.conditions.type"> </yi_dictionary_select>
          </el-form-item>
          <el-form-item :label="$t('chanpinfenlei')">
            <yi_dictionary_select :type="'GYLXCPFL'" :ids.sync="yt.conditions.value"> </yi_dictionary_select>
          </el-form-item>
          <el-form-item :label="$t('chanpinfenleiweikong')">
            <yi_dictionary_select :type="'SYSTEM_YES_NO'" :ids.sync="yt.conditions.isValueNull"> </yi_dictionary_select>
          </el-form-item>
          <el-form-item :label="$t('jianyanfenlei')">
            <yi_dictionary_select :type="'INSPECTION_CLASSIFICATION'" :ids.sync="yt.conditions.checkoutType"> </yi_dictionary_select>
          </el-form-item>
          <el-form-item :label="$t('paichanyanse')">
            <yi_dictionary_select :type="'PLAN_COLOR'" :ids.sync="yt.conditions.planColor"> </yi_dictionary_select>
          </el-form-item>
          <el-form-item :label="$t('erpwuliaobianma')">
            <el-input v-model="yt.conditions.erpMaterialCode"></el-input>
          </el-form-item>
          <el-form-item :label="$t('guige')">
            <el-input v-model="yt.conditions.spec"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button @click="yt.get(1)" type="primary" plain="plain">
              {{ $t('sousuo') }}
            </el-button>
            <el-button @click="yt.clear({ orderBy: 'createTime desc' })">{{ $t('chongzhi') }} </el-button>
            <yi_curd_expand_button></yi_curd_expand_button>
          </el-form-item>
        </el-form>
      </template>
      <!-- 左侧按钮插槽 -->
      <template #buttonsL="scope">
        <el-button
          size="mini"
          v-if="utils.checkPower('web_base_matter_create')"
          @click="
            yt.showEditDialog('xinzeng', null, 'w1');
            setDefaultValue();
          "
          type="primary"
        >
          {{ $t('xinzeng') }}
        </el-button>
        <el-button size="mini" v-if="utils.checkPower('web_base_matter_batchImport')" @click="show = !show" plain>
          {{ $t('daoru') }}
        </el-button>
        <el-button size="mini" v-if="utils.checkPower('web_base_matter_bom_batchImport')" @click="daorubomShow = !daorubomShow" plain>
          {{ $t('daoruwuliaobom') }}
        </el-button>

        <!-- 新增同步物料按钮 -->
        <el-button size="mini" :loading="yt.editObj.loading" v-if="utils.checkPower('openapi_custom_plan_send_sync_material_lth')" @click="syncMaterialLth" plain>
          {{ $t('openapi_custom_plan_send_sync_material_lth') }}
        </el-button>

        <el-button size="mini" v-if="utils.checkPower('web_base_matter_standard_brick_loss_import')" @click="yt.showEditDialog('daoruwuliaobiaozhunsunhao', null, 'w1')" plain>
          {{ $t('daoruwuliaobiaozhunsunhao') }}
        </el-button>
        <el-button size="mini" type="primary" @click="importSkillShow = !importSkillShow" v-if="utils.checkPower('web_base_matter_skill_requirement_batchImport')">
          {{ $t('daorujinengyaoqiu') }}
        </el-button>
        <!-- 金骏尚同步物料按钮 -->
        <div class="el-form-item el-form-item--mini" style="display: inline-flex; vertical-align: top; margin: 0 10px 0 30px" v-if="utils.checkPower('web_base_matter_jjsMaterialSync')">
          <label class="el-form-item__label">{{$t('shenheshijian')}}</label>
          <div class="el-form-item__content">
            <yi_time_input type="datetime" :is_current="false" :time.sync="jjsCreateTimeStart" format="yyyy-MM-dd HH:mm:ss"></yi_time_input>
          </div>
        </div>
        <el-button size="mini" :loading="yt.editObj.loading" v-if="utils.checkPower('web_base_matter_jjsMaterialSync')" @click="jjsMaterialSync"  type="primary">
          {{ $t('tongbu') }}
        </el-button>
        <el-button size="mini" :loading="yt.editObj.loading" v-if="utils.checkPower('web_base_matter_jjsInitialMaterialSync')" @click="jjsInitialMaterialSync"  type="primary">
          {{ $t('web_base_matter_jjsInitialMaterialSync') }}
        </el-button>
      </template>
      <!-- 右侧按钮插槽 -->
      <template #buttonsR>
        <el-button size="mini" icon="yicon yicon-export" :title="$t('daochu')" @click="exportExcel()"></el-button>
        <el-button size="mini" icon="yicon yicon-config_column" :title="$t('peizhilie')" @click="yt.showColumnsDialog()"></el-button>
      </template>
      <!-- 包装方式 -->
      <!-- <template #baozhuangfangshi="scope">
				{{ (scope.row.pack == '' || scope.row.pack == null) ? '-' : scope.row.pack }}
			</template> -->
      <!-- 描述 -->
      <!-- <template #miaoshu="scope">
				{{ (scope.row.describe == '' || scope.row.describe == null) ? '-' :scope.row.describe }}
			</template> -->
      <template #jiguangdayin="scope">
        <div>
          <span>{{ scope.row.laserPrint != null ? (scope.row.laserPrint === 0 ? $t('fou') : $t('shi')) : '' }}</span>
        </div>
      </template>
      <!-- 操作插槽 -->
      <template #caozuo="scope">
        <el-row :gutter="10">
          <el-col :span="0.1">
            <el-button type="text" @click="yt.showEditDialog('xiangqing', scope.row, '60%')">
              {{ $t('xiangqing') }}
            </el-button>
          </el-col>
          <el-col :span="0.1">
            <el-button type="text" v-if="utils.checkPower('web_base_matter_update')" @click="yt.showEditDialog('bianji', scope.row)">
              {{ $t('bianji') }}
            </el-button>
          </el-col>
          <el-col :span="0.1">
            <el-button type="text" :loading="yt.editObj.loading" v-if="utils.checkPower('web_base_matter_delete')" class="font-color-danger" @click="yt.remove(scope.row, '/web/basic/material/delete')">{{ $t('shanchu') }} </el-button>
          </el-col>
          <el-col :span="0.1">
            <el-button type="text" v-if="utils.checkPower('web_base_matter_copy')" @click="yt.showEditDialog('fuzhi', scope.row,null,beforeShowCopyDialog);">
              {{ $t('fuzhi') }}
            </el-button>
          </el-col>
        </el-row>
      </template>
      <!-- 底部插槽 -->
      <!-- <div slot="footer"></div> -->
    </yi_curd_table>

    <!-- 新增/编辑弹框 -->
    <el-dialog :show-close="true" :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog" :width="yt.dialogWidth" :close-on-click-modal="false" append-to-body="append-to-body">
      <!-- 新增表单 -->
      <template v-if="yt.editObj.action == 'xinzeng'">
        <div class="dialog-scroller">
          <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
            <el-form-item :label="$t('wuliaobianma')" required>
              <el-input v-model="yt.editObj.code"></el-input>
            </el-form-item>
            <el-form-item :label="$t('wuliaomingcheng')" required>
              <el-input v-model="yt.editObj.name"></el-input>
            </el-form-item>
            <el-form-item :label="$t('jibenfenlei')" required>
              <yi_dictionary_select :type="'CUSTOMER_MATERIAL_TYPE'" :ids.sync="yt.editObj.type"> </yi_dictionary_select>
            </el-form-item>
            <el-form-item :label="$t('chanpinfenlei')">
              <yi_dictionary_select :type="'GYLXCPFL'" :ids.sync="yt.editObj.value"> </yi_dictionary_select>
              <!--							<el-select filterable :clearable="true" v-model="yt.editObj.value"  collapse-tags>-->
              <!--								<el-option v-for="(item, index) in materialList" :key="index" :label="item.label"-->
              <!--									:value="item.value"></el-option>-->
              <!--							</el-select>-->
            </el-form-item>
            <el-form-item :label="$t('jianyanfenlei')">
              <yi_dictionary_select :type="'INSPECTION_CLASSIFICATION'" :ids.sync="yt.editObj.checkoutType"> </yi_dictionary_select>
            </el-form-item>
            <el-form-item :label="$t('morendanwei')">
              <yi_dictionary_select :type="'UNIT_CONVERSION_TYPE'" :ids.sync="yt.editObj.defaultUnit"> </yi_dictionary_select>
            </el-form-item>
            <el-form-item :label="$t('guige')">
              <el-input v-model="yt.editObj.spec"></el-input>
            </el-form-item>
            <el-form-item :label="$t('liaohao')">
              <el-input v-model="yt.editObj.no"></el-input>
            </el-form-item>
            <el-form-item :label="$t('jiliangdanwei')">
              <el-input v-model="yt.editObj.unit"></el-input>
            </el-form-item>
            <el-form-item :label="$t('maozhong(g)')">
              <el-input v-model="yt.editObj.grossWeight"></el-input>
            </el-form-item>
            <el-form-item :label="$t('jingzhong(g)')">
              <el-input v-model="yt.editObj.netWeight"></el-input>
            </el-form-item>
            <el-form-item :label="$t('shuikouzhong(g)')">
              <el-input v-model="yt.editObj.sprueWeight"></el-input>
            </el-form-item>
            <el-form-item :label="$t('yanse')">
              <el-input v-model="yt.editObj.color"></el-input>
            </el-form-item>
            <el-form-item :label="$t('sehao')">
              <el-input v-model="yt.editObj.colorNum"></el-input>
            </el-form-item>
            <el-form-item :label="$t('sefen')">
              <el-input v-model="yt.editObj.colorPowder"></el-input>
            </el-form-item>
            <el-form-item :label="$t('paichanyanse')">
              <yi_dictionary_select :type="'PLAN_COLOR'" :ids.sync="yt.editObj.planColor"> </yi_dictionary_select>
            </el-form-item>
            <el-form-item :label="$t('baozhuangfangshi')">
              <el-input v-model="yt.editObj.pack"></el-input>
            </el-form-item>
            <el-form-item :label="$t('caizhi')">
              <el-input v-model="yt.editObj.ingredient"></el-input>
            </el-form-item>
            <el-form-item :label="$t('tuhao')">
              <el-input v-model="yt.editObj.drawingNo"></el-input>
            </el-form-item>
            <el-form-item :label="$t('miaoshu')">
              <el-input v-model="yt.editObj.describe"></el-input>
            </el-form-item>
            <el-form-item :label="$t('shuikouyuntoubili')">
              <el-input-number v-model="yt.editObj.waterRatio" :precision="1" :step="0.1" :max="100" :min="0"></el-input-number>
            </el-form-item>
            <el-form-item :label="$t('hegelv')" v-if="passRateShow">
              <el-input-number v-model="yt.editObj.passRate" :precision="1" :step="0.1" :max="100" :min="0"></el-input-number>
            </el-form-item>
            <el-form-item :label="$t('kucunzuzhi')">
              <el-input v-model="yt.editObj.inventoryOrg"></el-input>
            </el-form-item>
            <el-form-item :label="$t('erpwuliaobianma')">
              <el-input v-model="yt.editObj.erpMaterialCode"></el-input>
            </el-form-item>
            <el-form-item :label="$t('shifouweixunijian')">
              <el-select v-model="yt.editObj.isVirtual">
                <el-option :label="$t('shi')" :value="true"></el-option>
                <el-option :label="$t('fou')" :value="false"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('shifouqiyong')" required>
              <el-select v-model="yt.editObj.enabled">
                <el-option :label="$t('shi')" :value="true"></el-option>
                <el-option :label="$t('fou')" :value="false"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('biaozhunsunhao')">
              <el-input-number :min="0" v-model="yt.editObj.standardBrickLoss"></el-input-number>
            </el-form-item>
          </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button :loading="store.state.global_loading" size="mini" @click="yt.req('POST', '/web/basic/material/create', beforeAdd)" type="primary">
            {{ $t('baocun') }}
          </el-button>
        </span>
      </template>
      <!-- 更新表单 -->
      <template v-if="yt.editObj.action == 'bianji'">
        <div class="dialog-scroller">
          <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
            <el-form-item class="noborder" :label="$t('wuliaobianma')" required>
              <el-input disabled v-model="yt.editObj.code"></el-input>
            </el-form-item>
            <el-form-item :label="$t('wuliaomingcheng')" required>
              <el-input v-model="yt.editObj.name"></el-input>
            </el-form-item>
            <el-form-item :label="$t('jibenfenlei')" required>
              <yi_dictionary_select :type="'CUSTOMER_MATERIAL_TYPE'" :ids.sync="yt.editObj.type"> </yi_dictionary_select>
            </el-form-item>
            <el-form-item :label="$t('chanpinfenlei')">
              <yi_dictionary_select :type="'GYLXCPFL'" :ids.sync="yt.editObj.value"> </yi_dictionary_select>
            </el-form-item>
            <el-form-item :label="$t('jianyanfenlei')">
              <yi_dictionary_select :type="'INSPECTION_CLASSIFICATION'" :ids.sync="yt.editObj.checkoutType"> </yi_dictionary_select>
            </el-form-item>
            <el-form-item :label="$t('morendanwei')">
              <yi_dictionary_select :type="'UNIT_CONVERSION_TYPE'" :ids.sync="yt.editObj.defaultUnit"> </yi_dictionary_select>
            </el-form-item>
            <el-form-item :label="$t('guige')">
              <el-input v-model="yt.editObj.spec"></el-input>
            </el-form-item>
            <el-form-item :label="$t('liaohao')">
              <el-input v-model="yt.editObj.no"></el-input>
            </el-form-item>
            <el-form-item :label="$t('jiliangdanwei')">
              <el-input v-model="yt.editObj.unit"></el-input>
            </el-form-item>
            <el-form-item :label="$t('maozhong(g)')">
              <el-input v-model="yt.editObj.grossWeight"></el-input>
            </el-form-item>
            <el-form-item :label="$t('jingzhong(g)')">
              <el-input v-model="yt.editObj.netWeight"></el-input>
            </el-form-item>
            <el-form-item :label="$t('shuikouzhong(g)')">
              <el-input v-model="yt.editObj.sprueWeight"></el-input>
            </el-form-item>
            <el-form-item :label="$t('yanse')">
              <el-input v-model="yt.editObj.color"></el-input>
            </el-form-item>
            <el-form-item :label="$t('sehao')">
              <el-input v-model="yt.editObj.colorNum"></el-input>
            </el-form-item>
            <el-form-item :label="$t('sefen')">
              <el-input v-model="yt.editObj.colorPowder"></el-input>
            </el-form-item>
            <el-form-item :label="$t('paichanyanse')">
              <yi_dictionary_select :type="'PLAN_COLOR'" :ids.sync="yt.editObj.planColor"> </yi_dictionary_select>
            </el-form-item>
            <el-form-item :label="$t('baozhuangfangshi')">
              <el-input v-model="yt.editObj.pack"></el-input>
            </el-form-item>
            <el-form-item :label="$t('caizhi')">
              <el-input v-model="yt.editObj.ingredient"></el-input>
            </el-form-item>
            <el-form-item :label="$t('tuhao')">
              <el-input v-model="yt.editObj.drawingNo"></el-input>
            </el-form-item>
            <el-form-item :label="$t('miaoshu')">
              <el-input v-model="yt.editObj.describe"></el-input>
            </el-form-item>
            <el-form-item :label="$t('shuikouyuntoubili')">
              <el-input-number v-model="yt.editObj.waterRatio" :precision="1" :step="0.1" :max="100" :min="0"></el-input-number>
            </el-form-item>
            <el-form-item :label="$t('hegelv')" v-if="passRateShow">
              <el-input-number v-model="yt.editObj.passRate" :precision="1" :step="0.1" :max="100" :min="0"></el-input-number>
            </el-form-item>
            <el-form-item :label="$t('kucunzuzhi')">
              <el-input v-model="yt.editObj.inventoryOrg"></el-input>
            </el-form-item>
            <el-form-item :label="$t('erpwuliaobianma')">
              <el-input v-model="yt.editObj.erpMaterialCode"></el-input>
            </el-form-item>
            <el-form-item :label="$t('shifouweixunijian')">
              <el-select v-model="yt.editObj.isVirtual">
                <el-option :label="$t('shi')" :value="true"></el-option>
                <el-option :label="$t('fou')" :value="false"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('shifouqiyong')" required>
              <el-select v-model="yt.editObj.enabled">
                <el-option :label="$t('shi')" :value="true"></el-option>
                <el-option :label="$t('fou')" :value="false"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('biaozhunsunhao')">
              <el-input-number :min="0" v-model="yt.editObj.standardBrickLoss"></el-input-number>
            </el-form-item>
          </el-form>
        </div>
        <template slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button size="mini" :loading="yt.editObj.loading" @click="yt.req('POST', '/web/basic/material/update', beforeAdd)" type="primary">
            {{ $t('baocun') }}
          </el-button>
        </template>
      </template>
      <!-- 详情 -->
      <template v-if="yt.editObj.action == 'xiangqing'">
        <!-- <div class="material"> -->
        <el-form size="mini" :inline="true" class="demo-form-inline">
          <el-form-item :label="$t('wuliaobianma')" class="noborder">
            <el-input disabled v-model="yt.editObj.code"> </el-input>
          </el-form-item>
          <el-form-item :label="$t('wuliaomingcheng')" class="noborder">
            <el-input disabled v-model="yt.editObj.name"> </el-input>
          </el-form-item>
        </el-form>
        <!-- </div> -->
        <el-tabs @tab-click="handleClick">
          <el-tab-pane :label="$t('wuliaoshuxing')">
            <div class="dialog-scroller">
              <matter_material ref="matter_material" :material="yt.editObj"></matter_material>
            </div>
          </el-tab-pane>
          <el-tab-pane :label="$t('wuliaoBOM')">
            <div class="dialog-scroller">
              <matter_bom ref="matter_bom" :row="yt.editObj"></matter_bom>
            </div>
          </el-tab-pane>
          <el-tab-pane :label="$t('morencangku')">
            <div class="dialog-scroller">
              <matter_warehouse ref="matter_warehouse" :material="yt.editObj"></matter_warehouse>
            </div>
          </el-tab-pane>
          <el-tab-pane :label="$t('web_base_package_rule')">
            <div class="dialog-scroller">
              <matter_package_rule ref="matter_package_rule" :material="yt.editObj"></matter_package_rule>
            </div>
          </el-tab-pane>
          <!--管理方式-->
          <el-tab-pane :label="$t('guanlifangshi')">
            <div class="dialog-scroller">
              <management_style ref="management_style" :material="yt.editObj"></management_style>
            </div>
          </el-tab-pane>
          <!--下架规则-->
          <el-tab-pane :label="$t('xiajiaguize')">
            <div class="dialog-scroller">
              <off_shelf_rule ref="off_shelf_rule" :material="yt.editObj"></off_shelf_rule>
            </div>
          </el-tab-pane>
          <!--规定产能-->
          <el-tab-pane :label="$t('guidingchanneng')">
            <div class="dialog-scroller">
              <regular_capacity ref="regular_capacity" :material="yt.editObj"></regular_capacity>
            </div>
          </el-tab-pane>
          <!--其他信息-->
          <el-tab-pane :label="$t('qitaxinxi')">
            <div class="dialog-scroller">
              <other_information ref="other_information" :material="yt.editObj"></other_information>
            </div>
          </el-tab-pane>
          <!--技能要求-->
          <el-tab-pane :label="$t('jinengyaoqiu')">
            <div class="dialog-scroller">
              <skill_requirement ref="skill_requirement" :material="yt.editObj"></skill_requirement>
            </div>
          </el-tab-pane>
        </el-tabs>
      </template>

      <template v-if="yt.editObj.action === 'daoruwuliaobiaozhunsunhao'">
        <div class="dialog-scroller">
          <yi_excel_import ref="standardBrickLossExport" @loading-start="startLoading" @loading-stop="stopLoading" :templatekey="'standard_brick_loss_import_key'" :uploadApi="'/web/basic/material/standardBrickLossImport'" />
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button type="default" size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button type="primary" size="mini" :loading="mainSubImportLoading" @click="mainSubImportData">{{ $t('baocun') }}</el-button>
        </span>
      </template>
      <!-- 复制表单 -->
      <template v-if="yt.editObj.action == 'fuzhi'">
        <div class="dialog-scroller">
          <el-form :inline="true" ref="form" size="mini" :label-width="'163px'">
            <el-form-item :label="$t('wuliaobianma')" required>
              <el-input v-model="yt.editObj.code"></el-input>
            </el-form-item>
            <el-form-item :label="$t('wuliaomingcheng')" required>
              <el-input v-model="yt.editObj.name"></el-input>
            </el-form-item>
            <el-form-item :label="$t('fuzhimojuyuxinwuliaoguanxi')" required>
              <el-select v-model="yt.editObj.isCopyMouldEquipment">
                <el-option :label="$t('shi')" :value="true"></el-option>
                <el-option :label="$t('fou')" :value="false"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('jibenfenlei')" required>
              <yi_dictionary_select :type="'CUSTOMER_MATERIAL_TYPE'" :ids.sync="yt.editObj.type"> </yi_dictionary_select>
            </el-form-item>
            <el-form-item :label="$t('chanpinfenlei')">
              <yi_dictionary_select :type="'GYLXCPFL'" :ids.sync="yt.editObj.value"> </yi_dictionary_select>
            </el-form-item>
            <el-form-item :label="$t('jianyanfenlei')">
              <yi_dictionary_select :type="'INSPECTION_CLASSIFICATION'" :ids.sync="yt.editObj.checkoutType"> </yi_dictionary_select>
            </el-form-item>
            <el-form-item :label="$t('morendanwei')">
              <yi_dictionary_select :type="'UNIT_CONVERSION_TYPE'" :ids.sync="yt.editObj.defaultUnit"> </yi_dictionary_select>
            </el-form-item>
            <el-form-item :label="$t('guige')">
              <el-input v-model="yt.editObj.spec"></el-input>
            </el-form-item>
            <el-form-item :label="$t('liaohao')">
              <el-input v-model="yt.editObj.no"></el-input>
            </el-form-item>
            <el-form-item :label="$t('jiliangdanwei')">
              <el-input v-model="yt.editObj.unit"></el-input>
            </el-form-item>
            <el-form-item :label="$t('maozhong(g)')">
              <el-input v-model="yt.editObj.grossWeight"></el-input>
            </el-form-item>
            <el-form-item :label="$t('jingzhong(g)')">
              <el-input v-model="yt.editObj.netWeight"></el-input>
            </el-form-item>
            <el-form-item :label="$t('yanse')">
              <el-input v-model="yt.editObj.color"></el-input>
            </el-form-item>
            <el-form-item :label="$t('sehao')">
              <el-input v-model="yt.editObj.colorNum"></el-input>
            </el-form-item>
            <el-form-item :label="$t('paichanyanse')">
              <yi_dictionary_select :type="'PLAN_COLOR'" :ids.sync="yt.editObj.planColor"> </yi_dictionary_select>
            </el-form-item>
            <el-form-item :label="$t('baozhuangfangshi')">
              <el-input v-model="yt.editObj.pack"></el-input>
            </el-form-item>
            <el-form-item :label="$t('caizhi')">
              <el-input v-model="yt.editObj.ingredient"></el-input>
            </el-form-item>
            <el-form-item :label="$t('tuhao')">
              <el-input v-model="yt.editObj.drawingNo"></el-input>
            </el-form-item>
            <el-form-item :label="$t('miaoshu')">
              <el-input v-model="yt.editObj.describe"></el-input>
            </el-form-item>
            <el-form-item :label="$t('shuikouyuntoubili')">
              <el-input-number v-model="yt.editObj.waterRatio" :precision="1" :step="0.1" :max="100" :min="0"></el-input-number>
            </el-form-item>
            <el-form-item :label="$t('hegelv')" v-if="passRateShow">
              <el-input-number v-model="yt.editObj.passRate" :precision="1" :step="0.1" :max="100" :min="0"></el-input-number>
            </el-form-item>
            <el-form-item :label="$t('kucunzuzhi')">
              <el-input v-model="yt.editObj.inventoryOrg"></el-input>
            </el-form-item>
            <el-form-item :label="$t('erpwuliaobianma')">
              <el-input v-model="yt.editObj.erpMaterialCode"></el-input>
            </el-form-item>
            <el-form-item :label="$t('shifouweixunijian')">
              <el-select v-model="yt.editObj.isVirtual">
                <el-option :label="$t('shi')" :value="true"></el-option>
                <el-option :label="$t('fou')" :value="false"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('shifouqiyong')" required>
              <el-select v-model="yt.editObj.enabled">
                <el-option :label="$t('shi')" :value="true"></el-option>
                <el-option :label="$t('fou')" :value="false"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('biaozhunsunhao')">
              <el-input-number :min="0" v-model="yt.editObj.standardBrickLoss"></el-input-number>
            </el-form-item>
          </el-form>
        </div>
        <template slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button size="mini" :loading="yt.editObj.loading" @click="yt.req('POST', '/web/basic/material/copy', beforeAdd)" type="primary">
            {{ $t('baocun') }}
          </el-button>
        </template>
      </template>
    </el-dialog>

    <!-- 导入excel -->
    <import-excel :show.sync="show" />
    <!-- 导入excel -->
    <matter_bom_import_excel :daorubomShow.sync="daorubomShow" />
    <!-- 导入技能要求excel -->
    <import_skill_excel :show.sync="importSkillShow" />
  </div>
</template>
<script type="text/javascript">
import matter_material from '@@/pages/web/base/matter/matter_material';
import list from '@@/pages/web/base/matter/import/list';
import matter_bom from '@@/pages/web/base/matter/matter_bom';
import matter_warehouse from '@@/pages/web/base/matter/matter_warehouse';
import matter_package_rule from '@@/pages/web/base/matter/matter_package_rule';
import management_style from '@@/pages/web/base/matter/management_style';
import off_shelf_rule from '@@/pages/web/base/matter/off_shelf_rule';
import regular_capacity from '@@/pages/web/base/matter/regular_capacity';
import other_information from '@@/pages/web/base/matter/other_information';
import skill_requirement from './skill_requirement.vue';
import importExcel from './import_excel';
import matter_bom_import_excel from '@@/pages/web/base/matter/matter_bom_import_excel';
import import_skill_excel from './import/skill_excel.vue';

export default {
  name: 'web_base_matter_list',
  components: {
    matter_material,
    list,
    matter_bom,
    matter_warehouse,
    matter_bom_import_excel,
    matter_package_rule,
    management_style,
    off_shelf_rule,
    regular_capacity,
    other_information,
    importExcel,
    skill_requirement,
    import_skill_excel
  },
  data() {
    return {
      mainSubImportLoading: false,
      show: false,
      daorubomShow: false,
      passRateShow: false,
      importSkillShow: false,
      jjsCreateTimeStart: null,
      materialList: [],
      activeName: 'attributes',
      list: [],
      columns: [
        {
          label: 'wuliaobianma',
          prop: 'code',
          sort: 'string',
          width: 130
        },
        {
          label: 'wuliaomingcheng',
          prop: 'name',
          sort: 'string',
          width: 130
        },
        {
          label: 'jibenfenlei',
          prop: 'type',
          type: 'dictionary',
          key: 'CUSTOMER_MATERIAL_TYPE',
          sort: 'string',
          width: 130
        },
        {
          label: 'chanpinfenlei',
          prop: 'label',
          sort: 'string',
          width: 130
        },
        {
          label: 'jianyanfenlei',
          prop: 'checkoutType',
          type: 'dictionary',
          key: 'INSPECTION_CLASSIFICATION',
          sort: 'string',
          width: 130
        },
        {
          label: 'morendanwei',
          prop: 'defaultUnit',
          type: 'dictionary',
          key: 'UNIT_CONVERSION_TYPE',
          width: 130
        },
        {
          label: 'guige',
          prop: 'spec'
          // width: 130
        },
        {
          label: 'dangqianliaohao',
          prop: 'no',
          width: 130
        },
        {
          label: 'jiliangdanwei',
          prop: 'unit',
          width: 130
        },
        {
          label: 'baozhuangfangshi',
          prop: 'pack',
          width: 130
          // type: 'slot'
        },
        {
          label: 'maozhong(g)',
          prop: 'grossWeight',
          width: 130
        },
        {
          label: 'jingzhong(g)',
          prop: 'netWeight',
          width: 130
        },
        {
          label: 'shuikouzhong(g)',
          prop: 'sprueWeight',
          width: 130
        },
        {
          label: 'yanse',
          prop: 'color',
          width: 130
        },
        {
          label: 'sehao',
          prop: 'colorNum',
          width: 130
        },
        {
          label: 'sefen',
          prop: 'colorPowder',
          width: 130
        },
        {
          label: 'paichanyanse',
          prop: 'planColor',
          type: 'dictionary',
          key: 'PLAN_COLOR',
          width: 130
        },
        {
          label: 'caizhi',
          prop: 'ingredient',
          width: 130
        },
        {
          label: 'tuhao',
          prop: 'drawingNo',
          width: 130
        },
        {
          label: 'miaoshu',
          prop: 'describe',
          width: 130
          // type: 'slot'
        },
        {
          label: 'chaoliangjieshouyuncha',
          prop: 'otherInfo.exceedAcceptDiff',
          width: 130
          // type: 'slot'
        },
        {
          label: 'shuikouyuntoubili',
          prop: 'waterRatio',
          width: 130
        },
        {
          label: 'kucunzuzhi',
          prop: 'inventoryOrg',
          width: 130
        },
        {
          label: 'erpwuliaobianma',
          prop: 'erpMaterialCode',
          width: 130
        },
        {
          label: 'jiguangdayin',
          prop: 'laserPrint',
          type: 'slot',
          width: 130
        },
        {
          label: 'shifouweixunijian',
          prop: 'isVirtual',
          type: 'bool',
          iln18: ['shi', 'fou'],
          width: 80
        },
        {
          label: 'shifouqiyong',
          prop: 'enabled',
          type: 'bool',
          iln18: ['shi', 'fou'],
          width: 80
        },
        {
          label: 'chuangjianshijian',
          prop: 'createTime',
          type: 'time',
          width: 150
          // format: 'YYYY-MM-DD'
        },
        {
          label: 'xiugaishijian',
          prop: 'updateTime',
          type: 'time',
          width: 150
          // format: 'YYYY-MM-DD'
        },
        {
          label: 'caozuo',
          type: 'slot',
          width: 200,
          fixed: 'right'
        }
      ]
    };
  },
  watch: {
    'yt.editObj.action': {
      handler(n, o) {
        console.log('ddddd', n);
        if (n == 'xinzeng') {
          // this.getMateria()
        }
      },
      immediate: false,
      deep: true
    }
  },
  created() {
    // this.getMateria()
    setTimeout(() => {
      this.yt.conditions = {
        orderBy: 'createTime desc'
      };
      this.yt.SELECT_URL = '/web/basic/material/getMaterialByIds';
      this.yt.SELECT_RESULT_KEY = 'data';
      this.yt.SELECT_ID = 'id';
      this.yt.SELECT_TITLE = 'name';
      this.yt.get(1);
      this.utils.event_hub.$on('BASE_MATTER_REFRESH', () => {
        this.yt.get(1);
      });
    }, 300);
    this.checkIsShowPassRate();
  },

  methods: {
    mainSubImportData() {
      let data = [...this.$refs.standardBrickLossExport.tableData];
      if (data.length <= 0) {
        this.$message.error(this.$t('qingshangchuanwenjian'));
        return;
      }
      //过滤出校验成功的数据
      let filterData = data.filter(item => {
        return item.result === undefined || item.result === '' || item.result === null;
      });
      console.log(filterData);
      if (filterData.length > 0) {
        this.mainSubImportLoading = true;
        return this.http
          .post('/web/basic/material/standardBrickLossImport?onlyValidate=false', filterData)
          .then(response => {
            this.utils.successMessage(this.$t(response.msg));
            this.yt.isShowEditDialog = false;
            this.yt.get(1);
          })
          .catch(err => {
            this.utils.errorMessage(this.$t(err));
          })
          .finally(() => {
            this.mainSubImportLoading = false;
          });
      } else {
        this.utils.errorMessage(this.$t('daoruxinxiyouwu'));
        this.$refs.standardBrickLossExport.exportExcel('导入报告', 'importExcelTable');
      }
    },

    startLoading() {
      this.mainSubImportLoading = true;
    },
    stopLoading() {
      this.mainSubImportLoading = false;
    },
    setDefaultValue() {
      this.yt.editObj.enabled = true;
    },
    afterGet() {
      for (let i = 0; i < this.yt.list.length; i++) {
        if (this.yt.list[i].passRate) {
          this.yt.list[i].passRate = this.yt.list[i].passRate.toFixed(1);
        }
      }
    },
    getExceptionType() {
      this.http
        .get('/web/andon/exceptionType/page', {
          params: {
            pageNum: 1,
            pageSize: 1000
          }
        })
        .then(res => {
          this.exceptionTypeList = res.data.rows;
        });
    },
    exportExcel() {
      // delete this.yt.conditions.orderBy
      let params = this.yt.conditions;
      return this.http
        .get('/web/report/export/basic_material_export', {
          params
        })
        .then(res => {
          this.$message.success(this.$t(res.msg));
          this.utils.event_hub.$emit('SHOW_HEADER_EXPORT_DIALOG');
        })
        .catch(error => {
          this.$message.error(this.$t(error));
        });
    },
    beforeAdd(params, url) {
      return params;
    },
    handleClick(tab, event) {
      this.$nextTick(() => {
        this.$refs.matter_material.yt.resetTableHeight();
      });
      this.$nextTick(() => {
        this.$refs.matter_bom.yt.resetTableHeight();
      });
      this.$nextTick(() => {
        this.$refs.matter_warehouse.yt.resetTableHeight();
      });
      this.$nextTick(() => {
        this.$refs.matter_package_rule.yt.resetTableHeight();
      });
      this.$nextTick(() => {
        this.$refs.management_style.yt.resetTableHeight();
      });
      this.$nextTick(() => {
        this.$refs.off_shelf_rule.yt.resetTableHeight();
      });
      this.$nextTick(() => {
        this.$refs.regular_capacity.yt.resetTableHeight();
      });
      this.$nextTick(() => {
        this.$refs.other_information.yt.resetTableHeight();
      });
      this.$nextTick(() => {
        this.$refs.skill_requirement.yt.resetTableHeight();
      });
    },
    checkIsShowPassRate() {
      for (let index = 0; index < this.store.state.customerTableFields.length; index++) {
        if (this.store.state.customerTableFields[index].tableId == 'web_order_management_production_plan_list_scheduling_stlt') {
          this.passRateShow = true;
        }
      }
    },
    syncMaterialLth() {
      this.yt.editObj.loading = true;
      this.http
        .get('/custom/lth/plan/sendSyncMaterial')
        .then(res => {
          this.$message.success(this.$t(res.msg));
          this.yt.editObj.loading = false;
        })
        .catch(error => {
          this.$message.error(this.$t(error));
          this.yt.editObj.loading = false;
        });
    },
    beforeShowCopyDialog(editObj){
      editObj.code = null;
      editObj.name = null;
      this.$set(editObj, 'isCopyMouldEquipment', true);
      return editObj;
    },
    jjsMaterialSync(){
      if(this.jjsCreateTimeStart == null){
        this.utils.errorMessage(this.$t('qingxuanze')+this.$t('shenheshijian'));
      }else {
        this.yt.editObj.loading = true;
        this.http.post('/custom/jinjunshang/material/sync',{
          createTimeStart:this.jjsCreateTimeStart
        }).then(res=>{
          this.utils.successMessage(this.$t(res.msg));
          this.yt.editObj.loading = false;
          this.yt.get();
        }).catch(error=>{
          this.utils.errorMessage(this.$t(error));
          this.yt.editObj.loading = false;
          this.yt.get();
        })
      }
    },
    jjsInitialMaterialSync(){
      this.yt.editObj.loading = true;
      this.http.post('/custom/jinjunshang/material/syncInit',{
        createTimeStart: new Date(2025,1,1,0,0,0,0).getTime()
      }).then(res=>{
        this.utils.successMessage('已发送至后台，需要一定时间，请在接口日志查看结果');
        this.yt.editObj.loading = false;
      }).catch(error=>{
        this.utils.errorMessage(this.$t(error));
        this.yt.editObj.loading = false;
      })
    },
  }
};
</script>
